module.exports = `${require.publicPath}default-avatar.9061b119.png`;